import styled from 'styled-components'
import { screen } from '../styles/mq'
export const Svg = styled.svg`
  display: inline-block;
  padding: 6px;
  width: 40px;

  @media (min-width: ${screen.m}) {
    width: 44px;
  }
`

export const IconPhotoshop = () => {
  return (
    <Svg viewBox="0 0 240 234">
      <path
        fill="#001E36"
        d="M42.5,0h155C221,0,240,19,240,42.5v149c0,23.5-19,42.5-42.5,42.5h-155C19,234,0,215,0,191.5v-149      C0,19,19,0,42.5,0z"
      />
      <path
        fill="#31A8FF"
        d="M54,164.1V61.2c0-0.7,0.3-1.1,1-1.1c1.7,0,3.3,0,5.6-0.1c2.4-0.1,4.9-0.1,7.6-0.2c2.7-0.1,5.6-0.1,8.7-0.2     c3.1-0.1,6.1-0.1,9.1-0.1c8.2,0,15,1,20.6,3.1c5,1.7,9.6,4.5,13.4,8.2c3.2,3.2,5.7,7.1,7.3,11.4c1.5,4.2,2.3,8.5,2.3,13     c0,8.6-2,15.7-6,21.3c-4,5.6-9.6,9.8-16.1,12.2c-6.8,2.5-14.3,3.4-22.5,3.4c-2.4,0-4,0-5-0.1c-1-0.1-2.4-0.1-4.3-0.1v32.1     c0.1,0.7-0.4,1.3-1.1,1.4c-0.1,0-0.2,0-0.4,0H55.2C54.4,165.4,54,165,54,164.1z M75.8,79.4V113c1.4,0.1,2.7,0.2,3.9,0.2H85     c3.9,0,7.8-0.6,11.5-1.8c3.2-0.9,6-2.8,8.2-5.3c2.1-2.5,3.1-5.9,3.1-10.3c0.1-3.1-0.7-6.2-2.3-8.9c-1.7-2.6-4.1-4.6-7-5.7     c-3.7-1.5-7.7-2.1-11.8-2c-2.6,0-4.9,0-6.8,0.1C77.9,79.2,76.5,79.3,75.8,79.4L75.8,79.4z"
      />
      <path
        fill="#31A8FF"
        d="M192,106.9c-3-1.6-6.2-2.7-9.6-3.4c-3.7-0.8-7.4-1.3-11.2-1.3c-2-0.1-4.1,0.2-6,0.7c-1.3,0.3-2.4,1-3.1,2     c-0.5,0.8-0.8,1.8-0.8,2.7c0,0.9,0.4,1.8,1,2.6c0.9,1.1,2.1,2,3.4,2.7c2.3,1.2,4.7,2.3,7.1,3.3c5.4,1.8,10.6,4.3,15.4,7.3     c3.3,2.1,6,4.9,7.9,8.3c1.6,3.2,2.4,6.7,2.3,10.3c0.1,4.7-1.3,9.4-3.9,13.3c-2.8,4-6.7,7.1-11.2,8.9c-4.9,2.1-10.9,3.2-18.1,3.2     c-4.6,0-9.1-0.4-13.6-1.3c-3.5-0.6-7-1.7-10.2-3.2c-0.7-0.4-1.2-1.1-1.1-1.9v-17.4c0-0.3,0.1-0.7,0.4-0.9     c0.3-0.2,0.6-0.1,0.9,0.1c3.9,2.3,8,3.9,12.4,4.9c3.8,1,7.8,1.5,11.8,1.5c3.8,0,6.5-0.5,8.3-1.4c1.6-0.7,2.7-2.4,2.7-4.2     c0-1.4-0.8-2.7-2.4-4c-1.6-1.3-4.9-2.8-9.8-4.7c-5.1-1.8-9.8-4.2-14.2-7.2c-3.1-2.2-5.7-5.1-7.6-8.5c-1.6-3.2-2.4-6.7-2.3-10.2     c0-4.3,1.2-8.4,3.4-12.1c2.5-4,6.2-7.2,10.5-9.2c4.7-2.4,10.6-3.5,17.7-3.5c4.1,0,8.3,0.3,12.4,0.9c3,0.4,5.9,1.2,8.6,2.3     c0.4,0.1,0.8,0.5,1,0.9c0.1,0.4,0.2,0.8,0.2,1.2v16.3c0,0.4-0.2,0.8-0.5,1C192.9,107.1,192.4,107.1,192,106.9z"
      />
    </Svg>
  )
}

export const IconIllustrator = () => {
  return (
    <Svg viewBox="0 0 240 234">
      <path
        fill="#300"
        d="M42.5 0h155C221 0 240 19 240 42.5v149c0 23.5-19 42.5-42.5 42.5h-155C19 234 0 215 0 191.5v-149C0 19 19 0 42.5 0z"
      />
      <path
        fill="#ff9a00"
        d="M116 140H78.8l-7.6 23.5c-.2.9-1 1.5-1.9 1.4H50.5c-1.1 0-1.4-.6-1.1-1.8l32.2-92.7c.3-1 .6-2.1 1-3.3.4-2.1.6-4.3.6-6.5-.1-.5.3-1 .8-1.1h25.9c.8 0 1.2.3 1.3.8l36.5 103c.3 1.1 0 1.6-1 1.6h-20.9c-.7.1-1.4-.4-1.6-1.1L116 140zm-31.4-20.3H110c-.6-2.1-1.4-4.6-2.3-7.2-.9-2.7-1.8-5.6-2.7-8.6-1-3.1-1.9-6.1-2.9-9.2s-1.9-6-2.7-8.9c-.8-2.8-1.5-5.4-2.2-7.8H97c-.9 4.3-2 8.6-3.4 12.9-1.5 4.8-3 9.8-4.6 14.8-1.4 5.1-2.9 9.8-4.4 14zM170 77c-3.3.1-6.5-1.2-8.9-3.5-2.3-2.5-3.5-5.8-3.4-9.2-.1-3.4 1.2-6.6 3.6-8.9s5.6-3.5 8.9-3.5c3.9 0 6.9 1.2 9.1 3.5 2.2 2.4 3.4 5.6 3.3 8.9.1 3.4-1.1 6.7-3.5 9.2-2.3 2.4-5.7 3.7-9.1 3.5zm-11.2 86.8v-77c0-1 .4-1.4 1.3-1.4h19.8c.9 0 1.3.5 1.3 1.4v77c0 1.1-.4 1.6-1.3 1.6h-19.6c-1 0-1.5-.6-1.5-1.6z"
      />
    </Svg>
  )
}

export const IconAfterEffects = () => {
  return (
    <Svg viewBox="0 0 240 234">
      <path
        fill="#00005B"
        d="M42.5,0h155C221,0,240,19,240,42.5v149c0,23.5-19,42.5-42.5,42.5h-155C19,234,0,215,0,191.5v-149      C0,19,19,0,42.5,0z"
      />
      <path
        fill="#9999FF"
        d="m96.4 140h-37.2l-7.6 23.6c-0.2 0.9-1 1.5-1.9 1.4h-18.8c-1.1 0-1.4-0.6-1.1-1.8l32.2-92.3c0.3-1 0.6-1.9 1-3.1 0.4-2.1 0.6-4.3 0.6-6.5-0.1-0.5 0.3-1 0.8-1.1h0.3 25.6c0.7 0 1.2 0.3 1.3 0.8l36.5 102c0.3 1.1 0 1.6-1 1.6h-20.9c-0.7 0.1-1.4-0.4-1.6-1.1l-8.2-24zm-31.4-19.9h25.4c-0.6-2.1-1.4-4.6-2.3-7.2-0.9-2.7-1.8-5.6-2.7-8.6-1-3.1-1.9-6.1-2.9-9.2s-1.9-6-2.7-8.9c-0.8-2.8-1.5-5.4-2.2-7.8h-0.2c-0.9 4.3-2 8.6-3.4 12.9-1.5 4.8-3 9.8-4.6 14.8-1.3 5.1-2.9 9.8-4.4 14z"
      />
      <path
        fill="#9999FF"
        d="m187 131h-31.7c0.4 3.1 1.4 6.2 3.1 8.9 1.8 2.7 4.3 4.8 7.3 6 4 1.7 8.4 2.6 12.8 2.5 3.5-0.1 7-0.4 10.4-1.1 3.1-0.4 6.1-1.2 8.9-2.3 0.5-0.4 0.8-0.2 0.8 0.8v15.3c0 0.4-0.1 0.8-0.2 1.2-0.2 0.3-0.4 0.5-0.7 0.7-3.2 1.4-6.5 2.4-10 3-4.7 0.9-9.4 1.3-14.2 1.2-7.6 0-14-1.2-19.2-3.5-4.9-2.1-9.2-5.4-12.6-9.5-3.2-3.9-5.5-8.3-6.9-13.1-1.4-4.7-2.1-9.6-2.1-14.6 0-5.4 0.8-10.7 2.5-15.9 1.6-5 4.1-9.6 7.5-13.7 3.3-4 7.4-7.2 12.1-9.5s10.3-3.1 16.7-3.1c5.3-0.1 10.6 0.9 15.5 3.1 4.1 1.8 7.7 4.5 10.5 8 2.6 3.4 4.7 7.2 6 11.4 1.3 4 1.9 8.1 1.9 12.2 0 2.4-0.1 4.5-0.2 6.4-0.2 1.9-0.3 3.3-0.4 4.2-0.1 0.7-0.7 1.3-1.4 1.3-0.6 0-1.7 0.1-3.3 0.2-1.6 0.2-3.5 0.3-5.8 0.3s-4.7-0.4-7.3-0.4zm-31.7-14.6h21.1c2.6 0 4.5 0 5.7-0.1 0.8-0.1 1.6-0.3 2.3-0.8v-1c0-1.3-0.2-2.5-0.6-3.7-1.8-5.6-7.1-9.4-13-9.2-5.5-0.3-10.7 2.6-13.3 7.6-1.2 2.3-1.9 4.7-2.2 7.2z"
      />
    </Svg>
  )
}

export const IconFigma = () => {
  return (
    <Svg viewBox="0 0 720 720">
      <rect fill="#1e1f26" width="720" height="720" rx="118.7" ry="118.7" />
      <circle fill="#1abcfd" cx="429" cy="365" r="66" />
      <path
        fill="#f34e1e"
        d="M297,167c-36.45,0-66,29.55-66,66s29.55,66,66,66h66v-132h-66Z"
      />
      <path
        fill="#a259ff"
        d="M297,299c-36.45,0-66,29.55-66,66s29.55,66,66,66h66v-132h-66Z"
      />
      <path
        fill="#ff7262"
        d="M429,167h-66v132h66c36.45,0,66-29.55,66-66s-29.55-66-66-66Z"
      />
      <path
        fill="#0acf82"
        d="M297,431c-36.45,0-66,29.55-66,66s29.55,66,66,66,66-29.55,66-66v-66h-66Z"
      />
    </Svg>
  )
}

export const IconHTML = () => {
  return (
    <Svg viewBox="0 0 34 38.57">
      <path
        fill="#e44d26"
        d="M3.09,34.71L0,0h34l-3.1,34.71-13.92,3.86-13.89-3.85Z"
      />
      <path fill="#f16529" d="M17,35.62l11.25-3.12,2.65-29.66h-13.9v32.78Z" />
      <path
        fill="#ebebeb"
        d="M17,15.71h-5.63l-.39-4.36h6.02v-4.25H6.33l.1,1.14,1.05,11.73h9.52v-4.26ZM17,26.77h-.02s-4.74-1.27-4.74-1.27l-.3-3.4h-4.27l.6,6.69,8.72,2.42h.02s0-4.43,0-4.43Z"
      />
      <path
        fill="#fff"
        d="M16.99,15.71v4.26h5.24l-.49,5.52-4.75,1.28v4.43l8.73-2.42.06-.72,1-11.21.1-1.14h-9.89ZM16.99,7.1v4.26h10.28l.08-.96.19-2.16.1-1.14h-10.66Z"
      />
    </Svg>
  )
}

export const IconCSS = () => {
  return (
    <Svg viewBox="0 0 88.97 100.71">
      <path
        fill="#1572b6"
        d="M8.1,90.62L0-.19h88.97l-8.1,90.8-36.43,10.1-36.33-10.09Z"
      />
      <path
        fill="#33a9dc"
        d="M44.48,92.99l29.44-8.16,6.93-77.59h-36.36v85.75Z"
      />
      <path
        fill="#fff"
        d="M44.48,40.14h14.74l1.02-11.4h-15.76v-11.14h27.93l-.27,2.99-2.74,30.69h-24.93v-11.14Z"
      />
      <path
        fill="#ebebeb"
        d="M44.55,69.06h-.05s-12.4-3.34-12.4-3.34l-.79-8.88h-11.18l1.56,17.49,22.81,6.33h.05v-11.6h0Z"
      />
      <path
        fill="#fff"
        d="M58.28,50.8l-1.34,14.92-12.42,3.35v11.59l22.83-6.33.17-1.88,1.94-21.65h-11.18Z"
      />
      <path
        fill="#ebebeb"
        d="M44.52,17.6v11.14h-26.9l-.22-2.5-.51-5.65-.27-2.99h27.9ZM44.48,40.14v11.14h-12.25l-.22-2.5-.51-5.65-.27-2.99h13.24Z"
      />
    </Svg>
  )
}

export const IconJavaScript = () => {
  return (
    <Svg viewBox="0 0 105.36 120">
      <path
        fill="#d4b830"
        d="M0,0l9.65,108.1,43.03,11.9,43.19-12.06L105.36,0H0ZM48.42,94.26l-30.72-8.53v-12.23l20.59,5.31V23.65h10.13v70.62h0ZM87.83,101.98l-35.15,10.13V9.97h43.35l-8.2,92.01Z"
      />
      <path
        fill="#fff"
        d="M48.42,94.26l-30.72-8.53v-12.23l20.59,5.31V23.65h10.13v70.62h0ZM87.83,101.98l-35.15,10.13V9.97h43.35l-8.2,92.01Z"
      />
      <path
        fill="#fdd83c"
        d="M52.68,9.97v102.14l35.15-10.13,8.2-92.01s-43.35,0-43.35,0ZM88.15,52.12l-2.41,34.58-28.63,7.56v-12.23l20.59-5.79.48-10.62-21.07,3.38V23.65h33.78l-.97,11.9h-22.04l-.16,18.5s20.43-1.93,20.43-1.93Z"
      />

      <path
        fill="#fff"
        d="M88.15,52.12l-2.41,34.58-28.63,7.56v-12.23l20.59-5.79.48-10.62-21.07,3.38V23.65h33.78l-.97,11.9h-22.04l-.16,18.5s20.43-1.93,20.43-1.93Z"
      />
    </Svg>
  )
}

export const IconTypeScript = () => {
  return (
    <Svg viewBox="0 0 835.58 835.58">
      <path
        fill="#0288d1"
        d="M835.58,835.58H0V0h835.58v835.58ZM40.96,40.96v753.66h753.66V40.96H40.96Z"
      />
      <path
        fill="#0288d1"
        d="M622.18,392.91c-4.81-.01-9.22.11-12.52.42-25.79,2.24-49.88,13.51-66.37,31.03-8.26,8.78-15.74,21.37-19.4,32.64-4.03,12.42-4,12.18-3.98,31.64.02,24.86,1.28,31.02,9.74,47.55,8.51,16.63,21.46,30.21,40.16,42.09,8.19,5.21,29.17,15.67,46.31,23.09,37.3,16.16,49.09,23.61,54.57,34.48l2.26,4.49v9.4c0,9.07-.04,9.53-1.88,13.27-4.21,8.65-14.14,15.73-26.85,19.16-4.81,1.29-7.01,1.47-17.76,1.48-10.52,0-13.07-.22-17.89-1.42-8.42-2.13-15.51-5.07-21.05-8.75-6.79-4.5-20.14-17.97-25.57-25.81-2.4-3.46-4.8-6.3-5.34-6.3-.89,0-46.91,26.31-54.95,31.41-2.71,1.72-3.39,2.5-3.39,3.88,0,2.86,10.75,19.11,19.18,28.98,17.16,20.12,51.57,37.85,82.06,42.29,12.05,1.75,32.07,2.32,46.05,1.29,9.16-.67,18.42-2.41,28.38-5.33,36-10.56,60.57-33,69.67-63.64,3.71-12.5,5.21-27.87,3.99-40.84-2.51-26.61-10.69-45.42-26.84-61.72-14.99-15.13-35.58-27.32-76.2-45.14-35.22-15.44-44.42-21.44-49.49-32.29-4.38-9.37-3.55-22.26,1.97-30.27,6.45-9.38,19.62-14.01,34.31-12.06,13.66,1.8,22.49,7.22,31.14,19.07,4.49,6.16,7.61,9.36,9.11,9.36s7.83-3.92,27.55-17.01c20.07-13.32,26.39-17.85,26.82-19.21.67-2.11-2.47-7.06-11.68-18.35-18.48-22.67-40.2-34.7-68.1-37.72-6.85-.74-15.95-1.16-23.97-1.18h0ZM400.28,396.75c-16.56-.01-35.47,0-56.49.02-108.99.11-134.29.29-134.97.99-.66.66-.84,7.35-.84,32.29v31.45l49.56.18,49.57.18v140.29c.01,77.16.19,140.95.43,141.75l.37,1.46h36.02c32.25,0,36.06-.07,36.41-1.02.22-.56.37-64.35.37-141.75v-140.73l49.56-.18,49.56-.18v-31.83c0-27.59-.11-31.91-.97-32.44-.45-.29-28.93-.46-78.61-.48h.01Z"
      />
    </Svg>
  )
}

export const IconReact = () => {
  return (
    <Svg viewBox="0 0 963.71 833.96">
      <path
        fill="#53c1de"
        d="M569.44,417.18c0-45.92-38.4-83.14-85.73-83.14s-85.73,37.22-85.73,83.14,38.4,83.1,85.73,83.1,85.73-37.22,85.73-83.1Z"
      />
      <path
        fill="#53c1de"
        d="M762.11,262.88c18.11-71.36,40.86-203.62-39.36-248.45-79.84-44.64-183.74,40.9-238.59,92.26C429.44,55.84,322.62-29.31,242.5,15.65c-79.81,44.8-55.2,174.88-36.7,246.66C131.33,282.78,3.71,326.94,3.71,417.18s127.49,138.02,201.5,158.5c-18.56,72.16-41.95,200.38,37.95,245.09,80.45,44.96,186.94-38.21,242.3-90.11,55.23,51.65,158.14,135.36,237.98,90.56,80.13-44.99,59.26-175.49,40.74-247.68,71.74-20.51,199.52-67.52,199.52-156.35s-128.32-133.89-201.6-154.3h0ZM753.02,535.29c-13.45-40.39-29.69-79.79-48.61-117.92,18.21-37.62,33.82-76.44,46.72-116.19,53.73,15.1,171.55,49.6,171.55,116s-113.06,101.86-169.66,118.11h0ZM702.91,786.78c-59.58,33.44-148.1-46.59-188.86-84.64,29.03-31.16,55.91-64.26,80.45-99.07,46.4-4,90.27-10.53,130.05-19.42,13.02,51.04,38.21,169.54-21.63,203.14h0ZM263.68,786.3c-59.62-33.31-32.35-147.71-18.69-200.9,39.3,8.45,82.85,14.5,129.34,18.18,26.56,36.22,54.4,69.54,82.43,98.72-34.66,32.48-133.22,117.47-193.09,84ZM44.67,417.18c0-67.26,117.15-101.54,172.1-116.58,12.93,40.19,28.56,79.46,46.78,117.54-18.46,38.63-34.28,78.47-47.36,119.23-52.38-14.53-171.52-52.9-171.52-120.19ZM263.04,50.08c59.84-33.6,152.64,48.19,192.38,84.99-29.41,30.85-56.74,63.63-81.79,98.11-45.12,4.06-88.35,10.56-128.1,19.33-14.91-57.92-42.27-168.9,17.5-202.43h0ZM623.84,276.41c30.62,3.74,60,8.74,87.55,14.85-8.29,25.7-18.59,52.58-30.72,80.13-17.61-32.44-36.57-64.13-56.83-94.98h0ZM484.16,163.49c18.91,19.87,37.86,42.05,56.51,66.11-37.8-1.72-75.67-1.72-113.47,0,17.89-22.96,36.9-45.02,56.96-66.11h0ZM287.14,371.36c-11.51-26.32-21.7-53.2-30.53-80.54,28.77-6.16,57.82-10.99,87.04-14.46-20.34,30.77-39.19,62.48-56.51,95.04v-.03ZM344.51,560.86c-29.69-3.12-59.21-7.73-88.45-13.79,8.45-26.56,18.88-54.14,31.1-82.18,17.56,32.89,36.7,64.92,57.34,95.97ZM485.31,673.66c-20.34-21.38-39.62-43.74-57.76-67.01,38.02,1.44,76.1,1.44,114.11-.19-17.62,23.35-36.43,45.78-56.35,67.2ZM681.06,463.45c12.8,28.35,23.65,55.81,32.22,81.89-29.58,6.44-59.46,11.37-89.54,14.78,20.45-31.42,39.65-63.68,57.28-96.64l.03-.03ZM571.62,564.96c-58.2,3.95-116.6,4.05-174.82.32-33.01-46.72-62.39-95.91-87.87-147.14,25.33-51.12,54.53-100.22,87.36-146.88,58.24-4.26,116.8-4.29,175.01,0,32.51,46.72,61.79,95.6,87.65,146.3-25.71,51.07-54.89,100.31-87.33,147.39ZM702.27,48.89c59.84,33.47,33.22,152.32,20.16,204.03-42.33-9.3-85.21-15.88-128.38-19.68-24.8-34.53-51.91-67.34-81.15-98.21,40.26-37.6,130.11-119.3,189.38-86.14h0Z"
      />
    </Svg>
  )
}

export const IconSvelte = () => {
  return (
    <Svg viewBox="0 0 714.24 858.02">
      <path
        transform="scale(0.8)"
        transform-origin="center"
        fill="#ff5722"
        d="M445.67.05c-44.5.86-88.78,13.22-127.9,38.14l-199.87,127.37C63.35,199.82,25.75,255.46,14.29,318.84c-9.56,52.91-1.2,107.5,23.75,155.12-17.1,25.95-28.75,55.1-34.25,85.68-11.53,64.73,3.52,131.37,41.77,184.85,79.7,114.04,237.12,147.83,350.92,75.33l199.88-126.83c54.48-34.33,92.06-89.93,103.61-153.28,9.52-52.89,1.14-107.45-23.83-155.04,17.09-25.96,28.77-55.1,34.33-85.68,11.5-64.73-3.56-131.36-41.77-184.85v-.61C616.4,38.69,530.63-1.59,445.67.05h0ZM463.21,97.95c49.44,2.27,95,27.48,123.19,68.16,23.01,32.14,32.08,72.21,25.14,111.13-1.2,6.3-2.78,12.52-4.75,18.62l-3.83,11.5-10.19-7.67c-23.65-17.36-50.09-30.58-78.17-39.08l-7.66-2.22.69-7.67c.89-10.56-1.99-21.09-8.12-29.73-11.52-16.17-31.84-23.53-51.04-18.47-4.34,1.15-8.48,2.96-12.27,5.37l-199.95,127.15c-9.87,6.24-16.69,16.33-18.78,27.82-2.02,11.76.74,23.85,7.67,33.57,11.39,16.3,31.68,23.87,50.96,19.01,4.33-1.18,8.46-2.99,12.27-5.37l76.64-48.59c12.52-8.03,26.23-14.06,40.61-17.86,64.42-16.78,132.46,8.44,170.37,63.15,22.99,32.15,32.05,72.21,25.13,111.13-6.84,38.2-29.46,71.75-62.31,92.43l-199.95,127.37c-12.56,7.97-26.25,13.99-40.61,17.85-64.45,16.73-132.49-8.51-170.44-63.22-22.98-32.15-32.02-72.22-25.06-111.13,1.13-6.26,2.71-12.43,4.74-18.47l3.76-11.5,10.27,7.67c23.61,17.23,49.96,30.35,77.95,38.78l7.66,2.22-.69,7.67c-.74,10.51,2.22,20.94,8.35,29.5,11.45,16.46,31.94,24.04,51.35,19.01,4.33-1.17,8.47-2.98,12.26-5.37l199.57-127.37c9.91-6.24,16.73-16.37,18.78-27.9,2.06-11.74-.7-23.81-7.67-33.49-11.45-16.46-31.94-24.04-51.35-19.01-4.34,1.15-8.47,2.96-12.26,5.36l-76.64,48.67c-12.53,7.95-26.2,13.94-40.54,17.78-64.34,16.63-132.23-8.57-170.14-63.15-22.91-32.18-31.89-72.24-24.91-111.13,6.84-38.2,29.46-71.76,62.3-92.43l200.18-127.37c12.46-7.93,26.05-13.93,40.31-17.78,15.39-4,31.29-5.66,47.18-4.93h0Z"
      />
    </Svg>
  )
}

export const IconSass = () => {
  return <Svg viewBox="0 0 48 48"></Svg>
}

export const IconCinema4D = () => {
  return (
    <Svg viewBox="0 0 602.89 604.95">
      <defs>
        <linearGradient
          id="Degradado_sin_nombre_17"
          data-name="Degradado sin nombre 17"
          x1="442.57"
          y1="72.92"
          x2="275.92"
          y2="382.83"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#fdfdfe" />
          <stop offset=".15" stopColor="#6472eb" />
          <stop offset=".52" stopColor="#2d39a1" />
          <stop offset="1" stopColor="#6070d7" />
        </linearGradient>
        <clipPath id="clippath">
          <path
            fill="none"
            d="M136.28,156.85c-.82.2-2.19,6.68-2.4,7.4-2.05,6.89-3.74,13.88-5.17,20.92-4.71,23.28-6.48,47.23-4.94,70.94,3.45,52.9,26.51,104.55,63.25,142.71,14.24,14.8,30.5,27.66,48.21,38.07,47.83,28.1,105.41,38.13,159.58,25.31,17.45-4.13,34.16-10.75,50.39-18.3,32.04-14.89,61.61-34.99,88.44-57.91,12.38-10.58,24.5-21.74,35.31-33.95.01-.01.02-.03.03-.04,0,0-145.45,261.67-318.68,223.66C77.08,537.65,17.88,384.89,17.88,384.89c0,0,8.04-201.73,118.41-228.05Z"
          />
        </clipPath>
        <linearGradient
          id="Degradado_sin_nombre_5"
          data-name="Degradado sin nombre 5"
          x1="40.6"
          y1="312.09"
          x2="546.27"
          y2="312.09"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#d4d6e5" />
          <stop offset=".53" stopColor="#ced0e1" />
          <stop offset="1" stopColor="#f3f3f8" />
        </linearGradient>
      </defs>
      <polygon
        fill="#020518"
        points="437.01 64.34 241.85 38.75 92.01 126.46 40.6 239.76 116.13 415.18 251.35 512.39 421.66 513.85 512.29 429.06 546.27 302.51 536.41 182.01 517.41 135.97 437.01 64.34"
      />
      <path
        fill="#020518"
        d="M415.2,33.56s99.65,18.76,143.5,137.17l-32.4,7.55-121.82-124.74,10.72-19.98Z"
      />
      <path
        fill="url(#Degradado_sin_nombre_17)"
        d="M421.72,57.15s79.49,26.31,111.28,117.31l-12.61,12.06s-33.44,3.84-68.52,110.73c-35.08,106.9-131.57,133.21-206.12,78.94-74.55-54.27-42.76-169.39,12.61-200.09,55.37-30.7,149.66-55.92,163.36-118.96Z"
      />
      <path
        fill="#f4f5f8"
        d="M421.75,57.21s11.84-22.6-11.3-38.2c-23.14-15.6-222.07-62.07-342.39,90.02C36.9,148.41,14.77,194.69,5.32,244.1c-8.61,45.03-6.67,91.83,5.17,136.09,11.67,43.67,32.76,85.05,62.21,119.42,33.67,39.29,78.05,69.23,126.59,86.94,13.73,5.01,27.82,9.04,42.13,12.02,54.75,11.41,112.6,7.44,165.31-11.22,9.29-3.29,18.35-7.3,27.2-11.63,39.96-19.58,74.67-48.67,102.03-83.68,6.8-8.7,13.15-17.74,19.06-27.06,43.48-68.54,69.21-166.77,24.54-277.91,0,0-12.55-30.18-49.39-11.76-16.14,8.07-33.11,87.01-35.93,126.09-2.81,39.08-33.72,202.01-170.8,247.79-137.08,45.78-292.49-59.94-272.08-228.21,20.4-168.27,199.97-203.81,286.93-218.86,86.96-15.05,83.46-44.91,83.46-44.91Z"
      />
      <path
        fill="url(#Degradado_sin_nombre_5)"
        d="M421.75,57.21s.99,26.58-58.94,40.47c-59.94,13.89-316.49,32.52-316.49,264.96,0,35.81,38.01,182,194.42,197.35s227.32-133.39,245.59-223.66c18.27-90.27,20.1-169.04,59.94-166.48,0,0-16.08,5.19-23.88,27.36-7.8,22.17-13.89,55.79-24.36,111.83-10.48,56.04-26.07,146.43-112.81,216.84-86.74,70.41-224.15,41.05-278.42-18.33-54.27-59.39-60.48-105.43-60.48-105.43,0,0-24.12-91.36,26.68-167.01,50.8-75.65,129.74-107.81,179.93-120.97,50.19-13.16,143.97-23.29,168.82-56.91Z"
      />
    </Svg>
  )
}

export const IconBlender = () => {
  return (
    <Svg viewBox="0 0 21.72 17.64">
      <path
        fill="#fff"
        d="M8.25,9.78c.08-1.48.81-2.79,1.91-3.72,1.07-.91,2.52-1.47,4.1-1.47s3.02.56,4.1,1.47c1.1.93,1.82,2.23,1.91,3.72.08,1.52-.53,2.94-1.6,3.99-1.1,1.07-2.65,1.74-4.4,1.74s-3.31-.67-4.4-1.74c-1.08-1.05-1.69-2.47-1.6-3.99h0Z"
      />

      <path
        fill="#265787"
        d="M11.32,9.92c.04-.72.4-1.36.93-1.81.52-.44,1.23-.72,2-.72s1.48.27,2,.72c.53.45.89,1.09.93,1.81.04.74-.26,1.44-.78,1.95-.54.52-1.3.85-2.15.85s-1.61-.33-2.15-.85c-.53-.51-.82-1.2-.78-1.95h0Z"
      />

      <path
        fill="#e87d0d"
        d="M6.65,11.38c0,.28.1.83.23,1.26.28.91.77,1.75,1.44,2.5.69.76,1.54,1.38,2.52,1.81,1.03.46,2.15.69,3.31.69,1.16,0,2.28-.24,3.31-.7.98-.44,1.83-1.05,2.52-1.82.67-.75,1.15-1.59,1.44-2.5.14-.46.23-.93.27-1.4.04-.46.02-.92-.04-1.39-.13-.9-.44-1.74-.92-2.51-.44-.71-1-1.33-1.68-1.85h0S12.28.27,12.28.27c0,0-.01,0-.02-.01-.45-.34-1.19-.34-1.68,0-.49.35-.55.92-.11,1.28h0s2.83,2.3,2.83,2.3H4.67s0,0-.01,0c-.71,0-1.4.47-1.53,1.06-.14.6.34,1.1,1.09,1.1h0s4.37,0,4.37,0L.78,12s-.02.01-.03.02C.01,12.58-.23,13.52.24,14.11c.47.6,1.47.6,2.21,0l4.26-3.48s-.06.47-.06.75h0ZM17.59,12.96c-.88.89-2.11,1.4-3.43,1.4-1.33,0-2.56-.5-3.44-1.39-.43-.43-.74-.94-.94-1.47-.19-.52-.26-1.08-.22-1.64.05-.55.21-1.07.47-1.54.26-.47.61-.89,1.04-1.24.85-.69,1.94-1.07,3.07-1.07,1.14,0,2.22.37,3.07,1.06.43.35.79.77,1.04,1.24.26.47.42.99.47,1.54.05.56-.03,1.12-.22,1.64-.19.53-.51,1.03-.94,1.47h0Z"
      />
    </Svg>
  )
}

export const IconNextJS = () => {
  return (
    <Svg viewBox="0 0 16 16">
      <g clip-path="url(#clip0_53_108)">
        <circle
          cx="8"
          cy="8"
          r="7.375"
          fill="black"
          stroke="var(--ds-gray-1000)"
          strokeWidth="1.25"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M10.63 11V5"
          stroke="url(#paint0_linear_53_108vsxrmxu21)"
          strokeWidth="1.25"
          stroke-miterlimit="1.41421"
        />
        <path
          fill-rule="evenodd"
          clipRule="evenodd"
          d="M5.995 5.00087V5H4.745V11H5.995V6.96798L12.3615 14.7076C12.712 14.4793 13.0434 14.2242 13.353 13.9453L5.99527 5.00065L5.995 5.00087Z"
          fill="url(#paint1_linear_53_108vsxrmxu21)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_53_108vsxrmxu21"
          x1="11.13"
          y1="5"
          x2="11.13"
          y2="11"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" />
          <stop offset="0.609375" stop-color="white" stop-opacity="0.57" />
          <stop offset="0.796875" stop-color="white" stop-opacity="0" />
          <stop offset="1" stop-color="white" stop-opacity="0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_53_108vsxrmxu21"
          x1="9.9375"
          y1="9.0625"
          x2="13.5574"
          y2="13.3992"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" />
          <stop offset="1" stop-color="white" stop-opacity="0" />
        </linearGradient>
        <clipPath id="clip0_53_108">
          <rect width="16" height="16" fill="red" />
        </clipPath>
      </defs>
    </Svg>
  )
}
export const IconTailwind = () => {
  return (
    <Svg viewBox="0 0 54 33">
      <g clip-path="url(#prefix__clip0)">
        <path
          fill="#38bdf8"
          fill-rule="evenodd"
          d="M27 0c-7.2 0-11.7 3.6-13.5 10.8 2.7-3.6 5.85-4.95 9.45-4.05 2.054.513 3.522 2.004 5.147 3.653C30.744 13.09 33.808 16.2 40.5 16.2c7.2 0 11.7-3.6 13.5-10.8-2.7 3.6-5.85 4.95-9.45 4.05-2.054-.513-3.522-2.004-5.147-3.653C36.756 3.11 33.692 0 27 0zM13.5 16.2C6.3 16.2 1.8 19.8 0 27c2.7-3.6 5.85-4.95 9.45-4.05 2.054.514 3.522 2.004 5.147 3.653C17.244 29.29 20.308 32.4 27 32.4c7.2 0 11.7-3.6 13.5-10.8-2.7 3.6-5.85 4.95-9.45 4.05-2.054-.513-3.522-2.004-5.147-3.653C23.256 19.31 20.192 16.2 13.5 16.2z"
          clip-rule="evenodd"
        />
      </g>
      <defs>
        <clipPath id="prefix__clip0">
          <path fill="#fff" d="M0 0h54v32.4H0z" />
        </clipPath>
      </defs>
    </Svg>
  )
}

export const IconGithub = () => {
  return (
    <Svg viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M10.303 16.652c-2.837-.344-4.835-2.385-4.835-5.028 0-1.074.387-2.235
      1.031-3.008-.279-.709-.236-2.214.086-2.837.86-.107 2.02.344
      2.708.967.816-.258 1.676-.386 2.728-.386 1.053 0 1.913.128
      2.686.365.666-.602 1.848-1.053 2.708-.946.3.581.344 2.085.064
      2.815.688.817 1.053 1.913 1.053 3.03 0 2.643-1.998 4.641-4.877
      5.006.73.473 1.224 1.504 1.224 2.686v2.235c0 .644.537 1.01 1.182.752
      3.889-1.483 6.94-5.372 6.94-10.185
      0-6.081-4.942-11.044-11.022-11.044-6.081 0-10.98 4.963-10.98 11.044a10.84
      10.84 0 0 0 7.112 10.206c.58.215 1.139-.172 1.139-.752v-1.719a2.768 2.768
      0 0 1-1.032.215c-1.418
      0-2.256-.773-2.857-2.213-.237-.58-.495-.924-.989-.988-.258-.022-.344-.129-.344-.258
      0-.258.43-.451.86-.451.623 0 1.16.386 1.719 1.181.43.623.881.903
      1.418.903.537 0 .881-.194 1.375-.688.365-.365.645-.687.903-.902Z"
      />
    </Svg>
  )
}

export const IconVercel = () => {
  return (
    <Svg viewBox="0 0 24 24">
      <circle cx="12" cy="12" r="12" fill="rgb(237,237,237)"></circle>
      <path fill="black" d="M12 5, 19 17, 5 17"></path>
    </Svg>
  )
}

export const IconPostgreSQL = () => {
  return (
    <Svg viewBox="0 0 432.071 445.383">
      <g
        fillRule="nonzero"
        clipRule="nonzero"
        stroke="#000000"
        strokeMiterlimit="4"
      ></g>
      <g
        fillRule="nonzero"
        clipRule="nonzero"
        fill="none"
        stroke="#FFFFFF"
        strokeWidth="12.4651"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="4"
      >
        <path
          fill="#000000"
          stroke="#000000"
          strokeWidth="37.3953"
          strokeLinecap="butt"
          strokeLinejoin="miter"
          d="M323.205,324.227c2.833-23.601,1.984-27.062,19.563-23.239l4.463,0.392c13.517,0.615,31.199-2.174,41.587-7c22.362-10.376,35.622-27.7,13.572-23.148c-50.297,10.376-53.755-6.655-53.755-6.655c53.111-78.803,75.313-178.836,56.149-203.322    C352.514-5.534,262.036,26.049,260.522,26.869l-0.482,0.089c-9.938-2.062-21.06-3.294-33.554-3.496c-22.761-0.374-40.032,5.967-53.133,15.904c0,0-161.408-66.498-153.899,83.628c1.597,31.936,45.777,241.655,98.47,178.31    c19.259-23.163,37.871-42.748,37.871-42.748c9.242,6.14,20.307,9.272,31.912,8.147l0.897-0.765c-0.281,2.876-0.157,5.689,0.359,9.019c-13.572,15.167-9.584,17.83-36.723,23.416c-27.457,5.659-11.326,15.734-0.797,18.367c12.768,3.193,42.305,7.716,62.268-20.224    l-0.795,3.188c5.325,4.26,4.965,30.619,5.72,49.452c0.756,18.834,2.017,36.409,5.856,46.771c3.839,10.36,8.369,37.05,44.036,29.406c29.809-6.388,52.6-15.582,54.677-101.107"
        />
        <path
          fill="#336791"
          stroke="none"
          d="M402.395,271.23c-50.302,10.376-53.76-6.655-53.76-6.655c53.111-78.808,75.313-178.843,56.153-203.326c-52.27-66.785-142.752-35.2-144.262-34.38l-0.486,0.087c-9.938-2.063-21.06-3.292-33.56-3.496c-22.761-0.373-40.026,5.967-53.127,15.902    c0,0-161.411-66.495-153.904,83.63c1.597,31.938,45.776,241.657,98.471,178.312c19.26-23.163,37.869-42.748,37.869-42.748c9.243,6.14,20.308,9.272,31.908,8.147l0.901-0.765c-0.28,2.876-0.152,5.689,0.361,9.019c-13.575,15.167-9.586,17.83-36.723,23.416    c-27.459,5.659-11.328,15.734-0.796,18.367c12.768,3.193,42.307,7.716,62.266-20.224l-0.796,3.188c5.319,4.26,9.054,27.711,8.428,48.969c-0.626,21.259-1.044,35.854,3.147,47.254c4.191,11.4,8.368,37.05,44.042,29.406c29.809-6.388,45.256-22.942,47.405-50.555    c1.525-19.631,4.976-16.729,5.194-34.28l2.768-8.309c3.192-26.611,0.507-35.196,18.872-31.203l4.463,0.392c13.517,0.615,31.208-2.174,41.591-7c22.358-10.376,35.618-27.7,13.573-23.148z"
        />
        <path d="M215.866,286.484c-1.385,49.516,0.348,99.377,5.193,111.495c4.848,12.118,15.223,35.688,50.9,28.045c29.806-6.39,40.651-18.756,45.357-46.051c3.466-20.082,10.148-75.854,11.005-87.281" />
        <path d="M173.104,38.256c0,0-161.521-66.016-154.012,84.109c1.597,31.938,45.779,241.664,98.473,178.316c19.256-23.166,36.671-41.335,36.671-41.335" />
        <path d="M260.349,26.207c-5.591,1.753,89.848-34.889,144.087,34.417c19.159,24.484-3.043,124.519-56.153,203.329" />
        <path
          strokeLinejoin="bevel"
          d="M348.282,263.953c0,0,3.461,17.036,53.764,6.653c22.04-4.552,8.776,12.774-13.577,23.155c-18.345,8.514-59.474,10.696-60.146-1.069c-1.729-30.355,21.647-21.133,19.96-28.739c-1.525-6.85-11.979-13.573-18.894-30.338    c-6.037-14.633-82.796-126.849,21.287-110.183c3.813-0.789-27.146-99.002-124.553-100.599c-97.385-1.597-94.19,119.762-94.19,119.762"
        />
        <path d="M188.604,274.334c-13.577,15.166-9.584,17.829-36.723,23.417c-27.459,5.66-11.326,15.733-0.797,18.365c12.768,3.195,42.307,7.718,62.266-20.229c6.078-8.509-0.036-22.086-8.385-25.547c-4.034-1.671-9.428-3.765-16.361,3.994z" />
        <path d="M187.715,274.069c-1.368-8.917,2.93-19.528,7.536-31.942c6.922-18.626,22.893-37.255,10.117-96.339c-9.523-44.029-73.396-9.163-73.436-3.193c-0.039,5.968,2.889,30.26-1.067,58.548c-5.162,36.913,23.488,68.132,56.479,64.938" />
        <path
          fill="#FFF"
          strokeWidth="4.155"
          strokeLinecap="butt"
          strokeLinejoin="miter"
          d="M172.517,141.7c-0.288,2.039,3.733,7.48,8.976,8.207c5.234,0.73,9.714-3.522,9.998-5.559c0.284-2.039-3.732-4.285-8.977-5.015c-5.237-0.731-9.719,0.333-9.996,2.367z"
        />
        <path
          fill="#FFF"
          strokeWidth="2.0775"
          strokeLinecap="butt"
          strokeLinejoin="miter"
          d="M331.941,137.543c0.284,2.039-3.732,7.48-8.976,8.207c-5.238,0.73-9.718-3.522-10.005-5.559c-0.277-2.039,3.74-4.285,8.979-5.015c5.239-0.73,9.718,0.333,10.002,2.368z"
        />
        <path d="M350.676,123.432c0.863,15.994-3.445,26.888-3.988,43.914c-0.804,24.748,11.799,53.074-7.191,81.435" />
        <path strokeWidth="3" d="M0,60.232" />
      </g>
    </Svg>
  )
}

export const IconStyledComponents = () => {
  return (
    <Svg viewBox="0 0 64 64">
      <polygon
        fill="oklch(0.8379 0.2386 85.2743 / 0.6)"
        stroke="oklch(0.8379 0.2386 85.2743 / 0.6)"
        strokeWidth="0"
        points="12.7962,10.3482 42.8954,25.0286 32.4747,58.5778 2.3755,43.8975"
      />
      <polygon
        fill="oklch(0.7945 0.258 149.7267 / 0.6)"
        stroke="oklch(0.7945 0.258 149.7267 / 0.6)"
        strokeWidth="0"
        points="61.6245,20.1025 51.2038,53.6518 32.4747,58.5778 42.8954,25.0286"
      />
      <polygon
        fill="oklch(0.7140 0.1845 266.6025 / 0.6)"
        stroke="oklch(0.7140 0.1845 266.6025 / 0.6)"
        strokeWidth="0"
        points="31.5253,5.4222 61.6245,20.1025 42.8954,25.0286 12.7962,10.3482"
      />
      <polygon
        fill="oklch(0.7361 0.2463 337.0433 / 0.6)"
        stroke="oklch(0.7361 0.2463 337.0433 / 0.6)"
        strokeWidth="0"
        points="21.1046,38.9714 2.3755,43.8975 32.4747,58.5778 51.2038,53.6518"
      />
      <polygon
        fill="oklch(0.6979 0.2752 25.7477 / 0.6)"
        stroke="oklch(0.6979 0.2752 25.7477 / 0.6)"
        strokeWidth="0"
        points="31.5253,5.4222 12.7962,10.3482 2.3755,43.8975 21.1046,38.9714"
      />
      <polygon
        fill="oklch(0.6888 0.2213 203.8675 / 0.6)"
        stroke="oklch(0.6888 0.2213 203.8675 / 0.6)"
        strokeWidth="0"
        points="31.5253,5.4222 21.1046,38.9714 51.2038,53.6518 61.6245,20.1025"
      />
    </Svg>
  )
}

export const IconAffinity = () => {
  return (
    <Svg viewBox="0 0 240 240">
      <path
        d="M12 0A12 12 90 000 12V180a12 12 180 0012 12H180a12 12 180 0012-12V12A12 12 90 00180 0H12Z"
        transform="scale(1.25)"
        fill="#a7f175"
      />
      <path
        d="M112.908,165.979c-10.413,0 -17.037,-6.317 -17.037,-14.329c0,-34.287 90.164,-41.151 90.164,-77.563c0,-22.213 -25.731,-31.787 -58.577,-31.787c-19.98,0 -42.571,3.698 -63.552,10.315l0,43.438c30.919,-22.52 65.272,-32.16 87.4,-32.16c13.914,0 23.355,3.882 23.355,10.838c0,28.658 -124.353,24.117 -124.353,86.042c0,23.736 16.321,37.335 39.283,37.335c34.732,0 61.003,-33.753 80.657,-74.897l3.982,1.43c-10.351,25.143 -31.771,52.712 -35.943,70.434l44.715,0l0,-91.685l-10.327,0c-14.99,32.574 -36.957,62.59 -59.767,62.59"
        fill="#0e1318"
        fillRule="nonzero"
      />
    </Svg>
  )
}
